import { useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import ajaxStations from "../../util/remote/ajaxStations";
import ajaxFuelPumps from "../../util/remote/ajaxFuelPumps";

const RegisterFuelPumpModal = (props) => {
  const [loading, setLoading] = useState(false);
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));

  // Station ID is FIXED to 1
  const [stationID, setStationID] = useState(station_idd);

  const [Pumpcode, setPumpcode] = useState("");

  const allRowsFilled = () => stationID && Pumpcode;

  // Submit
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }

    const data = {
      station_id: stationID,
      pump_code: Pumpcode,
    };

    setLoading(true);
    const response = await ajaxFuelPumps.create_Pumps(data);
    setLoading(false);

    if (response.status === "OK") {
      props.func();
      toast.success(response.message || "Fuel Pump registered successfully");
      resetForm();
    } else {
      toast.error(response.message);
    }
  };

  const resetForm = () => {
    setStationID(1);
    setPumpcode("");
  };

  // Fetch stations
  const [stations_list, setStationsList] = useState([]);

  const fetchStations = async () => {
    setLoading(true);

    const response = await ajaxStations.liststations_mini_data();

    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        response.details.map((d) => ({
          value: Number(d.id), // <-- FIX: convert ID to number
          label: d.station_name,
        }));

      setStationsList(list);
    } else {
      toast.error(response.message);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchStations();
  }, []);

  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>

      <button
        className="btn btn-primary"
        onClick={(e) => handleAdd(e)}
        disabled={!allRowsFilled() || loading}
      >
        {loading ? <Loader /> : "Register Fuel Pump"}
      </button>
    </>
  );

  return (
    <SystemModal title="Creating Fuel Pump" size="md" footer={RenderFooter}>
      <Toaster />

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Register Fuel Pump</h6>

                <form onSubmit={handleAdd}>
                  <div className="row mb-3">
                    {/* Station Select */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Station <span style={{ color: "red" }}>*</span>
                      </label>

                      <Select
                        options={stations_list}
                        value={
                          stations_list.find(
                            (s) => s.value === Number(stationID)
                          ) || null
                        }
                        isDisabled={true} // <-- disabled but shows the value
                        placeholder="Select station"
                      />
                    </div>

                    {/* Pump Code */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Fuel Pump Code <span style={{ color: "red" }}>*</span>
                      </label>

                      <input
                        type="text"
                        value={Pumpcode}
                        onChange={(e) => setPumpcode(e.target.value)}
                        className="form-control"
                        placeholder="Enter pump code, e.g Est001A"
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};

export default RegisterFuelPumpModal;
